import { RateDto } from './rate.dto';
import { TransactionSpecDto } from './transaction-spec.dto';

export class PriceLineDto {
  activity: string;
  currency: string;
  rates: RateDto[] = [];
  transactionSpecs: TransactionSpecDto[] = [];
  id: string;

  constructor(d?: PriceLineDto) {
    if (!d) {
      return;
    }
    this.id = d.id;
    this.activity = d.activity;
    this.currency = d.currency;
    if (d.rates) {
      this.rates = d.rates.map(i => new RateDto(i));
    }
    if (d.transactionSpecs) {
      this.transactionSpecs = d.transactionSpecs.map(
        t => new TransactionSpecDto(t)
      );
    }
  }
}
